// src/pages/OrderConfirmation.js
import React from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import './OrderConfirmation.css';

export default function OrderConfirmation() {
  const location = useLocation();
  const navigate = useNavigate();
  
  const orderData = location.state || {};
  const { 
    orderNumber, 
    total, 
    deliveryDate, 
    deliveryTime, 
    deliveryAddress,
    customer,
    email,
    phone,
    items
  } = orderData;

  // Redirect if no order data
  if (!orderNumber) {
    setTimeout(() => navigate('/order-now'), 2000);
    return (
      <div className="confirmation-page">
        <div className="confirmation-container">
          <p>No order found. Redirecting...</p>
        </div>
      </div>
    );
  }

  const formatPrice = (cents) => {
    return `$${(cents / 100).toFixed(2)}`;
  };

  return (
    <div className="confirmation-page">
      <div className="confirmation-container">
        <div className="success-icon">✓</div>
        <h1 className="confirmation-title">Order Confirmed!</h1>
        <p className="confirmation-subtitle">Thank you for your order</p>
        
        <div className="order-details">
          <div className="detail-row">
            <span className="detail-label">Order Number:</span>
            <span className="detail-value">{orderNumber}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Total Amount:</span>
            <span className="detail-value total-amount">{formatPrice(total)}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Delivery Date:</span>
            <span className="detail-value">{new Date(deliveryDate).toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Delivery Time:</span>
            <span className="detail-value">{deliveryTime}</span>
          </div>
        </div>

        <div className="confirmation-message">
          <h3>What's Next?</h3>
          <ul>
            <li>📧 You'll receive a confirmation email shortly</li>
            <li>👨‍🍳 Your chef will start preparing your meals</li>
            <li>🚗 We'll deliver to your door at the scheduled time</li>
            <li>🍽️ Enjoy your delicious meal!</li>
          </ul>
        </div>

        <div className="demo-banner">
          <p>🎭 <strong>Demo Mode:</strong> This is a demonstration order. No actual payment was processed and no delivery will be made.</p>
        </div>

        <div className="action-buttons">
          <Link to={`/track/${orderNumber}`} className="btn-track">📍 Track Your Order</Link>
          <Link to="/order-now" className="btn-secondary">Order Again</Link>
          <Link to="/" className="btn-primary">Back to Home</Link>
        </div>
      </div>
    </div>
  );
}

